import { createPersistedStoreWithShopId } from '~/utils/createPersistedStore';

export interface IReportPageTitleStoreState {
  pageTitle?: string;
  setPageTitle: (pageTitle: string) => void;
}
export const useReportPageTitleStore = createPersistedStoreWithShopId<IReportPageTitleStoreState>(
  'report-page-title',
  (set) => ({
    pageTitle: undefined,
    setPageTitle: (pageTitle) => set({ pageTitle }),
  }),
);
